module.exports = __webpack_public_path__ + "static/media/vote-form-img-red.2d177199.png";